import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Modal, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { Edit, Delete } from '@material-ui/icons';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { Spinner } from 'reactstrap';
import { update } from '../../../utils/fc';

const ModalDeleteBordero = ( props ) => {

    const [openModal, setOpenModal] = useState(false);
    const [isStatusLoading, setIsStatusLoading] = useState(false);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleDeleteBdro = async () => {
      setIsStatusLoading(true);
      await update('bdro', props.data.bdro_id, {bdro_ativo: 0})
      setIsStatusLoading(false);
      handleCloseModal();
      props.preloading();
    }

    return (
      <>
        <Button variant="" onClick={handleOpenModal}>
          <Delete />
        </Button>
        <Dialog
          fullWidth
          maxWidth= 'sm'
          open={openModal}
          onClose={handleCloseModal}
          PaperProps={{
            style: {
              margin: 'auto', // Ensures the modal aligns well within the screen center
              width: "350px"
            },
            component: 'form',
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>Confirma deleção</DialogTitle>
          <DialogContent sx={{overflow: "visible"}}>
            Tem certeza que deseja excluir este item?
          </DialogContent>
          <DialogActions>
            {isStatusLoading &&(
              <Button
                autoFocus
                margin="dense"
                id="entregaRevInterna"
                name="entrega_rev_interna"
                label="Entrega a Revisao Interna"
                variant="outlined"
                disabled
                endIcon={<Spinner/>}
              >Aguarde</Button>
            )}

            {!isStatusLoading && (
              <div className="d-flex justify-content-start mb-3">
                  <Button
                  className='text-success'
                  onClick={() => {
                    handleDeleteBdro()
                  }}
                  >
                    Deletar
                  </Button>
                  <Button
                  onClick={handleCloseModal}
                  >
                    Cancelar
                  </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </>
    )
}

export default ModalDeleteBordero;
